import React, { Component } from "react";

export default class Logo extends Component {
  render() {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2576.1 1126.02"
      >
        <title>logo</title>
        <g id="hashtag_path">
          <path
            d="M530.37,528.74,510.83,633H631.4v91.25H493.71L466.83,863.58H348.69l26.89-139.31H225.67L198.79,863.58H81.47l26.89-139.31H0V633H125.46L145,528.74H32.59V438.3H162.94L189,299.8H306.33L280.26,438.3H430.17l26.88-138.5H574.37L548.3,438.3H659.1v90.44Zm-117.31,0H262.33L242.79,633h149.9Z"
            style={{ fill: "red" }}
          />
        </g>
        <g id="fuiste_path">
          <path
            d="M528.74,79.16v68H760.59v66.11H528.74v129H434.69V11.64H768.5V79.16Z"
            style={{ fill: "#1f140f" }}
          />
          <path
            d="M909.52,11.64V184.38c0,55.86,34.92,95.43,100.1,95.43,62.86,0,99.64-39.57,99.64-95.43V11.64h94V194.16c0,95.44-68.91,159.69-193.69,159.69C884.38,353.85,815,289.13,815,193.22V11.64Z"
            style={{ fill: "#1f140f" }}
          />
          <path
            d="M1275.88,342.21V11.64h94V342.21Z"
            style={{ fill: "#1f140f" }}
          />
          <path
            d="M1412.72,269.11l67-47c27.47,38.66,78.22,65.19,145.72,65.19,60.08,0,88-12.58,88-38.64,0-20.49-14-28.88-53.09-33.07L1558.9,204.39c-80.53-8.84-120.11-38.64-120.11-99.62C1438.79,39.11,1503,0,1616.17,0c83.36,0,148.53,21.89,190,68.44l-59.59,49.83c-24.22-33.07-71.71-52.61-135-52.61-51.22,0-78.69,12.09-78.69,34.9,0,20,13.5,27.94,55.88,32.13L1679.5,142c91.26,9.31,129,36.31,129,97.31,0,73.57-68,114.54-187.64,114.54C1523.07,353.85,1446.7,321.25,1412.72,269.11Z"
            style={{ fill: "#1f140f" }}
          />
          <path
            d="M2191.59,84.74H2054.23V342.21h-94V84.74H1822.84V11.64h368.75Z"
            style={{ fill: "#1f140f" }}
          />
          <path
            d="M2576.1,276.1v66.11H2239V11.64h333.82V77.75H2333.07v66.12h231.85v61.46H2333.07V276.1Z"
            style={{ fill: "#1f140f" }}
          />
        </g>
        <g id="tu_path">
          <path
            d="M1025.26,655.11H784.91v450.54H620.34V655.11H380V527.21h645.26Z"
            style={{ fill: "#1f140f" }}
          />
          <path
            d="M1259.85,527.21V829.46c0,97.77,61.1,167,175.16,167,110,0,174.35-69.26,174.35-167V527.21h164.58V846.58c0,167-120.58,279.44-338.93,279.44-219.16,0-340.55-113.25-340.55-281.08V527.21Zm229.74-136.88h159.69l-146.65,96.14H1366.57Z"
            style={{ fill: "#1f140f" }}
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/logo.js